









































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SumupUnitEditTab from "../../components/SumupUnitEditTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import DropArea from "../../components/DropArea.vue";
import { SumupGroup, SumupUnit, BaseSumupUnit } from "../../modules/teacher/PracticeSumupUnitMultiEdit"

export interface Data {
  tabNo: number
  sumup_group_id: string
  sumup_group: SumupGroup
  sumup_units: SumupUnit[]
  base_sumup_units: BaseSumupUnit[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
    "sumup-unit-edit-tab": SumupUnitEditTab,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 2,
      sumup_group_id: null,
      sumup_group: null,
      sumup_units: [],
      base_sumup_units: [],
      errors: new Array<string>(),
    });

    /******************************
     * 追加ボタンクリック
     ******************************/

    const addEmptySumupUnit = () => {
      state.sumup_units.push(createEmptySumupUnit());
    }

    /******************************
     * 空の集計レコード追加
     ******************************/

    const createEmptySumupUnit = () => {
      const sumup_unit = new SumupUnit();
      sumup_unit.id = null;
      sumup_unit.name = "";     
      sumup_unit.sumup_unit_ids = []; 
      sumup_unit.result_published = true;
      return sumup_unit;
    }

    /******************************
     * 集計レコード削除
     ******************************/

    const deleteSumupUnit = (sumup_unit: SumupUnit) => {
      const idx = state.sumup_units.indexOf(sumup_unit);
      state.sumup_units.splice(idx, 1);
    }

    /******************************
     * 保存ボタンクリック
     ******************************/
    
    const saveClick = async () => {

      state.errors = [];

      for(let i = 0; i < state.sumup_units.length; i++){
        const sumup_unit = state.sumup_units[i];
        if(!sumup_unit.name){
          state.errors.push(`${i + 1}行目の教科名が未入力です。`);
        }

        if(sumup_unit.sumup_unit_ids.length == 0){
          state.errors.push(`${i + 1}行目の教科が未選択です。`);
        }

        if(!sumup_unit.score_bunpu_range){
          state.errors.push(`${i + 1}行目の得点分布単位が入力されていません。`);
        }else if(!Common.isFloatOrInteger(sumup_unit.score_bunpu_range)){
          state.errors.push(`${i + 1}行目の得点分布単位に数字以外が入力されています。`);
        }

        if(!sumup_unit.sort_no){
          state.errors.push(`${i + 1}行目の表示順が入力されていません。`);
        }else if(!Common.isInteger(sumup_unit.sort_no)){
          state.errors.push(`${i + 1}行目の表示順に整数以外が入力されています。`);
        }
      }

      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("集計情報を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/practice_sumup_unit_multi_edit/update/${state.sumup_group_id}`, {sumup_units: state.sumup_units}).then(response => {
        alert("処理が完了しました。")
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      
      await http.get(`/api/teacher/practice_sumup_unit_multi_edit/?sumup_group_id=${state.sumup_group_id}`).then(response => {
        
        state.sumup_group = new SumupGroup(response.data.sumup_group);
        state.base_sumup_units = response.data.base_sumup_units.map((x: any) => {
          const base_sumup_unit = new BaseSumupUnit();
          base_sumup_unit.id = x.id;
          base_sumup_unit.name = x.name;
          return base_sumup_unit;
        });

        if(response.data.sumup_units.length > 0){
          response.data.sumup_units.forEach((x: any) => {
            const sumup_unit = createEmptySumupUnit();
            sumup_unit.id = x.id;
            sumup_unit.name = x.name;
            sumup_unit.score_bunpu_range = x.score_bunpu_range;
            sumup_unit.sort_no = x.sort_no;
            sumup_unit.result_published = x.result_published;
            sumup_unit.sumup_unit_ids = x.sumup_unit_ids;
            state.sumup_units.push(sumup_unit);
          });
        }else{
          // 教科集計未登録の場合、空の入力ボックスを追加
          state.sumup_units.push(createEmptySumupUnit());
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`処理に失敗しました。一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      addEmptySumupUnit,
      deleteSumupUnit,
      saveClick
    };
  }
})
